<template>
  <a-row class="search-params-margin">
    <a-col :span="labelCol">
      <div class="label-title">{{title}}</div>
    </a-col>
    <a-col :span="valueCol">
      <a-input-number v-model:value="inputValue" :disabled="disabled" @change="onChange" :min="min" :max="max" />
    </a-col>
  </a-row>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  props: {
    value: {
      type: Number,
      default: 0
    },

    title: {
      type: String,
      default: '标题'
    },

    labelCol: {
      type: Number,
      default: 10
    },

    valueCol: {
      type: Number,
      default: 12
    },
    disabled: {
      type: Boolean,
      default: false
    },
    after: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: -9999
    },
    max: {
      type: Number,
      default: 9999
    }
  },
  emits: ['ok', 'update:value'],
  setup (props, { emit }) {
    const inputValue = ref(props.value)

    watch(props, e => {
      inputValue.value = e.value
    })

    const onChange = e => {
      emit('ok', e)
      emit('update:value', e)
    }

    return {
      inputValue,
      onChange
    }
  }
})
</script>
